module.exports = __webpack_public_path__ + "img/2.96cb2d39.jpg";